"use client";

import { createContext, useContext, useEffect, useState, Dispatch, SetStateAction  } from "react";
import { Queries } from "../../services/queries";

interface CartContextType {
  count: number;
  reloadCart: () => void;
  setCartCount: Dispatch<SetStateAction<number>>;
}

const CartContext = createContext<CartContextType>({
  count: 0,
  reloadCart: () => {},
  setCartCount: () => {},
});

export function  CartProvider({ children, client }) {
  const [count, setCount] = useState(0);

  async function loadCart() {
     console.log("loadCart called, client:", client);
try{    const queries = new Queries(client);
    const c = await queries.getCartCount();
    console.log("loadCart got count:", c);
    setCount(c ?? 0);}
    catch (error) {
      console.error("Error loading cart count:", error);
    }
  }

  useEffect(() => {
    loadCart();
  }, []);


  return (

    <CartContext.Provider
      value={{
        count,
        reloadCart: loadCart,
        setCartCount: setCount, // direkter Setter, kein Request nötig
      }}
    >
      {children}
    </CartContext.Provider>
  );
}


export function useCart() {
  return useContext(CartContext);
}
